"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _moment = _interopRequireDefault(require("moment"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var format = "MM/DD/YYYY";
var DateFormatter = function DateFormatter(_ref) {
  var value = _ref.value;
  return !!value && _react["default"].createElement("div", null, _moment["default"].isMoment(value) ? value.format(format) : (0, _moment["default"])(value).format(format));
};
DateFormatter.propTypes = {
  value: _propTypes["default"].any
};
DateFormatter.defaultProps = {
  value: null
};
var _default = DateFormatter;
exports["default"] = _default;